import { chain, map } from 'lodash';
import moment from 'moment';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

import AddressForm from '../../../containers/AddressForm/AddressForm';
import UserAddress from './UserAddress';

import { makeStyles } from '@material-ui/core/styles';
import modalStyle from '../../../assets/jss/material-kit-pro-react/modalStyle.js';
const useStyles = makeStyles(theme => ({
  ...modalStyle(theme),
  header: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  paper: {
    backgroundColor: 'transparent',
    padding: '20px 0px'
  }
}));

export default function UserAddresses(props) {
  const classes = useStyles();
  const [openModal, setOpenModal] = useState(false);
  const [address, setAddress] = useState(null);
  const futurePickUpsByAddress = chain(props.user.upcomingPickUps)
    .filter(({ date }) => moment().isBefore(date))
    .keyBy('pickUpAddressId')
    .value();

  return (
    <div>
      <h4 className={classes.header}>
        <span>Addresses:</span>
        <Button
          size="small"
          color="primary"
          variant="contained"
          onClick={() => {
            setAddress({});
            setOpenModal(true);
          }}
        >
          Add Address
        </Button>
      </h4>
      <Divider />
      <Paper className={classes.paper}>
        <Grid container>
          {map(props.user.addresses, a => (
            <Grid item key={a.id} xs={12} sm={4} md={4}>
              <UserAddress
                address={a}
                disabled={!!futurePickUpsByAddress[a.id]}
                onEdit={() => {
                  setAddress(a);
                  setOpenModal(true);
                }}
                removeAddress={props.removeAddress}
              />
            </Grid>
          ))}
        </Grid>
      </Paper>

      {address && (
        <Dialog
          open={openModal}
          onClose={() => setOpenModal(false)}
          onExited={() => {
            setAddress(null);
            props.getUser(props.user.id);
          }}
        >
          <DialogTitle>Edit Address</DialogTitle>
          <DialogContent>
            <AddressForm
              user={props.user}
              address={address}
              onCreate={() => {
                setAddress(null);
                props.getUser(props.user.id);
              }}
            />
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}

UserAddresses.propTypes = {
  getUser: PropTypes.func.isRequired,
  removeAddress: PropTypes.func.isRequired,
  user: PropTypes.shape({}).isRequired
};
